import { getAppLocale } from '../app-locale';

export function convertDate(date) {
  const locale = getAppLocale();
  return new Date(date).toLocaleDateString(locale,
    {
      month: 'short',
      year: 'numeric',
      day: 'numeric'
    })
}
